import { useUserStore } from '@/configs/store';
import { useGlobalUserFilterModel } from '@/features/globalUserFilter';
import { useIsLogsReadOnly } from '@/features/logsMode';

export const useCanOpenContextMenu = () => {
  const { isLoading: isUserLoading, user: currentUser, isAdmin } = useUserStore();
  const { loadingStage, isViewingSelf } = useGlobalUserFilterModel();
  const isLogsReadOnly = useIsLogsReadOnly();

  const canOpen =
    !isUserLoading &&
    !loadingStage.isLoading &&
    !!currentUser &&
    !isLogsReadOnly &&
    (isViewingSelf || isAdmin);

  return canOpen;
};
